
const createStatusRequest = (acao) => {
    return {
        SUCCESS: acao + '_SUCCESS',
        ERROR: acao + '_ERROR',
        LOADING: acao + '_LOADING'
    }
};

const CONSTANTS = {
    PARENTESCO_CODIGO_CONJUGE: 5,
    _TIPO_PESSOA: {
        /** 
            [Description("Fiador")]
            Fiador = 1,
            [Description("Conjuge")]
            Conjuge = 2,
            [Description("Responsavel")]
            Responsavel = 3
        */
        CONJUGE: 2,
        FIADOR: 1,
        RESPONSAVEL: 3
    },
    _PERMISSAO: {
        naoPermitido: 0,
        somenteEndereco: 1,
        tudo: 2
    },
    _STEPS: {
        CURSO_INTERESSE: {
            index: 0,
            text: "Curso de Interesse"
        },
        DADOS_INTERESSADO: {
            index: 1,
            text: "Dados do Interessado"
        },
        DADOS_GRUPO_FAMILIAR: {
            index: 2,
            text: "Dados Sobre Grupo Familiar"
        },
        FINALIZAR: {
            index: 3,
            text: "Finalizar Solicitação"
        }
    },
    CHANGE_CAPTCHA: 'CHANGE_CAPTCHA',
    SET_ACEITE: 'SET_ACEITE',
    SET_ERROR: 'SET_ERROR',
    SET_ACEITE_REGULAMENTO: 'SET_ACEITE_REGULAMENTO',
    CARREGAR_FINANCIAMENTOS_DISPONIVEIS: createStatusRequest('CARREGAR_FINANCIAMENTOS_DISPONIVEIS'),
    CARREGAR_LIST_DEFICIENCIA: createStatusRequest('CARREGAR_LIST_DEFICIENCIA'),
    CARREGAR_LIST_TPMORADIA: createStatusRequest('CARREGAR_LIST_TPMORADIA'),
    CARREGAR_LIST_PARENTESCO: createStatusRequest('CARREGAR_LIST_PARENTESCO'),
    CARREGAR_LIST_NACIONALIDADE: createStatusRequest('CARREGAR_LIST_NACIONALIDADE'),
    CARREGAR_LIST_CIDADES: createStatusRequest('CARREGAR_LIST_CIDADES'),
    CONSULTA_CEP: createStatusRequest('CONSULTA_CEP'),
    GET_DADOS_INTERESSADO_CONJUGE_CPF: createStatusRequest('GET_DADOS_INTERESSADO_CONJUGE_CPF'),
    NEXT_STEP: 'NEXT_STEP',
    BACK_STEP: 'BACK_STEP',
    SET_ABA: 'SET_ABA',
    CHANGE_CURSO: 'CHANGE_CURSO',
    CHANGE_PERIODO: 'CHANGE_PERIODO',
    CHANGE_POLO: 'CHANGE_POLO',
    CHANGE_PERCENTDESEJADO: 'CHANGE_PERCENTDESEJADO',
    POSSUI_ALGUMA_DEFICIENCIA: 'POSSUI_ALGUMA_DEFICIENCIA',
    //-
    CHANGE_CAMPO_GENERICO_INTERESSADO: 'CHANGE_CAMPO_GENERICO_INTERESSADO',
    CHANGE_CAMPO_GENERICO_CONJUGE: 'CHANGE_CAMPO_GENERICO_CONJUGE',
    CHANGE_CAMPO_GENERICO_GRUPO_FAMILIAR: 'CHANGE_CAMPO_GENERICO_GRUPO_FAMILIAR',
    GET_DADOS_INTERESSADO_CPF: createStatusRequest('GET_DADOS_INTERESSADO_CPF'),
    EDITAR_CPF: 'EDITAR_CPF',
    CONJUGE_EDITAR_CPF: 'CONJUGE_EDITAR_CPF',
    ERROR_INTERESSADO: 'ERROR_INTERESSADO',
    SET_LIST_GRUPO_FAMILIAR: 'SET_LIST_GRUPO_FAMILIAR',
    ADD_PESSOA_NO_GRUPO_FAMILIAR: 'ADD_PESSOA_NO_GRUPO_FAMILIAR',
    DELETE_PESSOA_NO_GRUPO_FAMILIAR: 'DELETE_PESSOA_NO_GRUPO_FAMILIAR',
    UPDATE_PESSOA_NO_GRUPO_FAMILIAR: 'UPDATE_PESSOA_NO_GRUPO_FAMILIAR',
    CHANGE_MOTIVO: 'CHANGE_MOTIVO',
    FINALIZAR_CADASTRO: createStatusRequest('FINALIZAR_CADASTRO'),
    RESET: 'RESET',
    SET_IS_ALTERACAO: 'SET_IS_ALTERACAO',
    CHANGE_ALTERACAO_GENERICO: 'CHANGE_ALTERACAO_GENERICO',
    GET_DADOS_ALTERACAO: createStatusRequest('GET_DADOS_ALTERACAO'),
    GET_DADOS_FORM_FIADORES: createStatusRequest('GET_DADOS_FORM_FIADORES'),
    SET_INDEX_ABAFIADOR: 'SET_INDEX_ABAFIADOR',
    CHANGE_CAMPO_GENERICO_FIADOR: 'CHANGE_CAMPO_GENERICO_FIADOR',
    GET_DADOS_FORM_FIADORES_CPF: createStatusRequest('GET_DADOS_FORM_FIADORES_CPF'),
    CARREGAR_LIST_CIDADES_FIADOR: createStatusRequest('CARREGAR_LIST_CIDADES_FIADOR'),
    EDITAR_FIADOR_CPF: 'EDITAR_FIADOR_CPF',
    CONSULTA_CEP_FIADOR: createStatusRequest('CONSULTA_CEP_FIADOR'),
    CONCLUIR_ENVIO_FIADORES: createStatusRequest('CONCLUIR_ENVIO_FIADORES'),
    ERROR_PESSOA_FIADOR: 'ERROR_PESSOA_FIADOR',
    ERROR_PESSOA_FIADOR_LIMPAR: 'ERROR_PESSOA_FIADOR_LIMPAR',
    ADD_FORM_FIADOR: 'ADD_FORM_FIADOR',     
    REMOVE_FORM_FIADOR: 'REMOVE_FORM_FIADOR',
    ADD_ITEM_ARQUIVO_FAMILIAR: 'ADD_ITEM_ARQUIVO_FAMILIAR',
    REMOVE_ITEM_ARQUIVO_FAMILIAR: 'REMOVE_ITEM_ARQUIVO_FAMILIAR',
    UPDATE_ITEM_ARQUIVO_FAMILIAR: 'UPDATE_ITEM_ARQUIVO_FAMILIAR',
    //
    ADD_ITEM_ARQUIVO_FIADOR: 'ADD_ITEM_ARQUIVO_FIADOR',
    REMOVE_ITEM_ARQUIVO_FIADOR: 'REMOVE_ITEM_ARQUIVO_FIADOR',
    UPDATE_ITEM_ARQUIVO_FIADOR: 'UPDATE_ITEM_ARQUIVO_FIADOR',
    NUMERO_DE_FIADORES: 1,
    PROGRESS_FINALIZAR_CADASTRO: 'PROGRESS_FINALIZAR_CADASTRO',
    PROGRESS_FINALIZAR_FIADOR: 'PROGRESS_FINALIZAR_FIADOR'
};

export default CONSTANTS;


// WEBPACK FOOTER //
// ./src/constants/index.js